const SDK_VERSION = '7.102.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
